import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomeUnitStart,
  getHomeUnitSuccess,
  getHomeUnitFailure,
} from "../reducers/getHomeUnitReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHomeUnit = createAsyncThunk(
  "getHomeUnit",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomeUnitStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetUnit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomeUnitSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomeUnitFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
